class Helpers {

    static unique(length) {
        var uid = "",
            possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        length = ( length === undefined ) ? 10 : length;

        for( var i=0; i < length; i++ ) {
            uid += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return uid;
    }

    static isJSON(str) {

        if ( str && typeof str === "string" ) {

            if ( str.match(/^(\[|\{).*(\]|\})$/s) ) {
                return true;
            }
        }

        return false;
    }

    static isBase64(str) {
        let regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
        return regex.test(str);
    }
}

export default Helpers;
